import { useBreakpoints } from '#cutils/hooks/useBreakpoint';
import { MAP_BREAKPOINTS, getRatioForBreakpoint } from '#utils/article/static-map-breakpoints';

export function useMapBreakpoints() {
	const currentBreakpoint = useBreakpoints(MAP_BREAKPOINTS);

	if (!currentBreakpoint) {
		return null;
	}

	return { currentBreakpoint, ratio: getRatioForBreakpoint(currentBreakpoint) };
}
